/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  DirectoryRoleSetupHiddenAttributeKey,
  DirectoryRoleSetupHiddenAttributeKey$inboundSchema,
} from "./directoryrolesetuphiddenattributekey.js";
import {
  DirectoryRoleSetupPreviewItem,
  DirectoryRoleSetupPreviewItem$inboundSchema,
} from "./directoryrolesetuppreviewitem.js";

export type DirectoryRoleSetupPreviewResult = {
  /**
   * Attribute keys left out of items because they have more than max_values_per_attribute_key distinct values. Their values can still be mapped one at a time with setDirectoryRoleMappings.
   */
  hiddenAttributeKeys: Array<DirectoryRoleSetupHiddenAttributeKey>;
  /**
   * One item per live directory group and mappable attribute value.
   */
  items: Array<DirectoryRoleSetupPreviewItem>;
  /**
   * The limit on distinct values above which an attribute key is left out.
   */
  maxValuesPerAttributeKey: number;
};

/** @internal */
export const DirectoryRoleSetupPreviewResult$inboundSchema: z.ZodMiniType<
  DirectoryRoleSetupPreviewResult,
  unknown
> = z.pipe(
  z.object({
    hidden_attribute_keys: z.array(
      DirectoryRoleSetupHiddenAttributeKey$inboundSchema,
    ),
    items: z.array(DirectoryRoleSetupPreviewItem$inboundSchema),
    max_values_per_attribute_key: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "hidden_attribute_keys": "hiddenAttributeKeys",
      "max_values_per_attribute_key": "maxValuesPerAttributeKey",
    });
  }),
);

export function directoryRoleSetupPreviewResultFromJSON(
  jsonString: string,
): SafeParseResult<DirectoryRoleSetupPreviewResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DirectoryRoleSetupPreviewResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DirectoryRoleSetupPreviewResult' from JSON`,
  );
}
